import { render, staticRenderFns } from "./ExportOrder.vue?vue&type=template&id=b2067172&scoped=true"
import script from "./ExportOrder.vue?vue&type=script&lang=js"
export * from "./ExportOrder.vue?vue&type=script&lang=js"
import style0 from "./ExportOrder.vue?vue&type=style&index=0&id=b2067172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2067172",
  null
  
)

export default component.exports